import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import MainContainer from "../components/MainContainer";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <MainContainer hideLogo>
      <Wrapper>
        <Kanji
          as={motion.div}
          initial={{ opacity: 0, scale: 1.3 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1, ease: [0.22, 0.72, 0.18, 1] }}
        >
          感謝
        </Kanji>

        <CheckWrap
          as={motion.div}
          initial={{ scale: 0, rotate: -30 }}
          animate={{ scale: 1, rotate: 0 }}
          transition={{
            type: "spring",
            stiffness: 220,
            damping: 16,
            delay: 0.2,
          }}
        >
          <svg viewBox="0 0 52 52">
            <motion.circle
              cx="26"
              cy="26"
              r="24"
              fill="none"
              stroke="#7dd490"
              strokeWidth="2"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.7, delay: 0.35, ease: "easeOut" }}
            />
            <motion.path
              d="M15 27 L23 34 L37 19"
              fill="none"
              stroke="#7dd490"
              strokeWidth="3.4"
              strokeLinecap="round"
              strokeLinejoin="round"
              initial={{ pathLength: 0 }}
              animate={{ pathLength: 1 }}
              transition={{ duration: 0.45, delay: 0.85, ease: "easeOut" }}
            />
          </svg>
        </CheckWrap>

        <Heading
          as={motion.h1}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.5,
            duration: 0.7,
            ease: [0.22, 0.72, 0.18, 1],
          }}
        >
          Hvala na porudžbini!
        </Heading>

        <Text
          as={motion.p}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.65,
            duration: 0.7,
            ease: [0.22, 0.72, 0.18, 1],
          }}
        >
          Porudžbina je uspešno evidentirana — potvrda stiže na tvoj e-mail.
          <br />
          Plaćaš kuriru pri preuzimanju.
        </Text>

        <Ctas
          as={motion.div}
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.8,
            duration: 0.7,
            ease: [0.22, 0.72, 0.18, 1],
          }}
        >
          <BtnRed
            onClick={() => {
              navigate("/prodavnica");
              window.scrollTo({ top: 0, behavior: "instant" });
            }}
          >
            Nastavi kupovinu <i>→</i>
          </BtnRed>
          <BtnGhost
            onClick={() => {
              navigate("/");
              window.scrollTo({ top: 0, behavior: "instant" });
            }}
          >
            Nazad na početnu
          </BtnGhost>
        </Ctas>
      </Wrapper>
    </MainContainer>
  );
};

export default SuccessPage;

const Wrapper = styled.div`
  min-height: 70vh;
  width: 100%;
  padding: 6rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--text, #f4f2ee);
  position: relative;
  overflow: hidden;
`;

const Kanji = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: var(--font-kanji);
  font-size: clamp(24rem, 40vh, 42rem);
  line-height: 1;
  color: rgba(254, 95, 85, 0.05);
  white-space: nowrap;
  pointer-events: none;
  user-select: none;
`;

const CheckWrap = styled.div`
  width: 9.6rem;
  height: 9.6rem;
  margin-bottom: 2.6rem;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Heading = styled.h1`
  font-family: "Anton", sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: clamp(3.2rem, 5.4vw, 5.4rem);
  line-height: 1;
  letter-spacing: 0.01em;
  margin-bottom: 1.6rem;
  position: relative;
  z-index: 1;
`;

const Text = styled.p`
  font-size: 1.5rem;
  font-family: "Poppins-Regular";
  color: var(--muted, #8e8c94);
  line-height: 1.8;
  margin-bottom: 3.2rem;
  position: relative;
  z-index: 1;
`;

const Ctas = styled.div`
  display: flex;
  gap: 1.4rem;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
  z-index: 1;
`;

const BtnRed = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  font-family: "Anton", sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 1.3rem;
  padding: 1.5rem 3rem;
  border-radius: 0.4rem;
  border: none;
  cursor: pointer;
  background: var(--red, #fe5f55);
  color: var(--bg0, #0a0a0c);
  transition: all 0.3s var(--ease, ease);

  i {
    font-style: normal;
    transition: transform 0.3s var(--ease, ease);
  }

  &:hover {
    background: var(--red-deep, #e04a40);

    i {
      transform: translateX(0.4rem);
    }
  }
`;

const BtnGhost = styled(BtnRed)`
  background: transparent;
  color: var(--text, #f4f2ee);
  border: 1px solid var(--line2, rgba(255, 255, 255, 0.14));

  &:hover {
    background: transparent;
    border-color: var(--red, #fe5f55);
    color: var(--red, #fe5f55);
  }
`;
